import React from 'react';
import HttpStatusPage from 'app/components/pages/HttpStatusPage';
import { useI18n } from 'app/components/localization';

export const NotFound: React.FC = () => {
  const { t } = useI18n();
  return (
    <HttpStatusPage
      status={404}
      header={t('http-status-page.404.header')}
      message={t('http-status-page.404.message')}
    />
  );
};

export default NotFound;
